export default "__VITE_ASSET__8fc155eb__"